module.exports = __webpack_public_path__ + "static/media/1.9525ed0f.jpg";